import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    errorPage: null,
    updateModal: false
  },
  getters: {
    updateModal (state) {
      return state.updateModal
    },
    errorPage (state) {
      return state.errorPage
    },
    whatsappLink () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        return 'https://api.whatsapp.com/send?phone=5581992231656'
      } else {
        return 'https://web.whatsapp.com/send?phone=5581992231656'
      }
    }
  },
  mutations: {
    'SET_ERROR_PAGE' (state, errorPage) {
      if (errorPage) state.errorPage = errorPage
      else state.errorPage = null
    },
    'SET_UPDATE_MODAL' (state, isVisible) {
      state.updateModal = isVisible
    }
  },
  actions: {
  }
})
